import PlatformTestScenarios from './PlatformTestScenarios'

/* eslint-disable camelcase, no-await-in-loop */
export default class PPTABLETestScenarios extends PlatformTestScenarios {
  async multiBets_bet1_bet2_bet3_bet4_settleWin() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()

        const BET_LENGTH = 4
        const betIndexes = []
        for (let betIndex = 0; betIndex < BET_LENGTH; betIndex += 1) {
          if (!betIndex) {
            await this.requests.bet({ betIndexes: [betIndex], data: { betAmount: this.formData.betAmount * 3 } })
          } else {
            await this.requests.bet({ betIndexes: [betIndex] })
          }
          betIndexes.push(betIndex)
        }

        await this.requests.settleWin({ betIndexes })

        await this.requests.getBalance({ action: 'settle' })
      },
    )
  }
}
